"use client";

import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Badge,
  Spinner,
  Button,
} from "react-bootstrap";
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import api from "../../services/api";
import Swal from "sweetalert2";

const StoreOrderDetails = () => {
  const { orderCode } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] =
    useState(null);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const { data } =
          await api.get(
            `/orders/store/${orderCode}`
          );

        setOrder(
          data?.data || data
        );
      } catch {
        Swal.fire({
          icon: "error",
          title: "خطا",
          text:
            "دریافت جزئیات سفارش انجام نشد.",
          confirmButtonText:
            "باشه",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderCode]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!order) {
    return null;
  }

  const items =
    order.items ||
    order.orderItems ||
    [];

  return (
    <>
      <Card className="border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h3 className="mb-1">
                سفارش {orderCode}
              </h3>

              <span className="text-secondary">
                {order.createdAt
                  ? new Date(
                      order.createdAt
                    ).toLocaleString(
                      "fa-IR"
                    )
                  : ""}
              </span>
            </div>

            <Badge bg="primary">
              {order.status}
            </Badge>
          </div>
        </Card.Body>
      </Card>

      <Card className="border-0 rounded-3">
        <Card.Body className="p-4">
          <h4 className="mb-4">
            اقلام سفارش
          </h4>

          <Table
            hover
            responsive
            className="align-middle"
          >
            <thead>
              <tr>
                <th>محصول</th>
                <th>تعداد</th>
                <th>قیمت</th>
                <th>جمع</th>
              </tr>
            </thead>

            <tbody>
              {items.map(
                (item, index) => {
                  const product =
                    item.storeProduct ||
                    item.product ||
                    item;

                  const price =
                    Number(
                      item.price ||
                        product.price ||
                        0
                    );

                  return (
                    <tr
                      key={
                        item.id ||
                        index
                      }
                    >
                      <td>
                        {product.name ||
                        item.title ||
                          "-"}
                      </td>

                      <td>
                        {item.quantity}
                      </td>

                      <td>
                        {price.toLocaleString(
                          "fa-IR"
                        )}
                      </td>

                      <td>
                        {(
                          price *
                          item.quantity
                        ).toLocaleString(
                          "fa-IR"
                        )}
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </Table>

          <div className="text-end mt-4">
            <h3>
              مبلغ قابل پرداخت:{" "}
              {Number(
                order.payableAmount ||
                  order.totalAmount ||
                  0
              ).toLocaleString(
                "fa-IR"
              )}{" "}
              تومان
            </h3>
          </div>

          <Button
            variant="secondary"
            onClick={() =>
              navigate(
                "/store/orders"
              )
            }
          >
            بازگشت
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

export default StoreOrderDetails;